
import React from 'react'
 
export const Versioning = ({title, desc, ok}) => {

    return ok && (
        <div className="edit-page">
        <div className="edit-info">
            <div className="flex">
                    <div>
                        <h2>{title}</h2>
                        <br />
                        <small>
                            { desc.substr(0,250).split(/\r\n|\n|\r/) }
                        </small>
                    </div>
                    <div className="actions">
                       
                    </div>
                </div>
                <br />
            <div className="flex">
                <div className="flex-start">
                  
                </div>
                <div className="drafting flex-end">
                    <small>Updates: &nbsp; </small>
                    {/** 
                    { value: 's', name: '#099df8d (son)' },
                    { value: 'm', name: '#7dsas9ad8' },
                    { value: 'l', name: '#8s9a7da' },
                    **/}
                    <input placeholder='versions' />
                </div>
            </div>
        </div>
    </div>
    )
}
